/* eslint-disable pii/no-phone-number */

import { Payload } from '../payload.model';
import { ZenitList, Section, ZenitEventName, ZenitPageType, ZenitClickOrigin } from '../zenit-general.model';

import { BasicEvent } from './basic-event.model';

/**
 * Version of the AddToCart event
 */
type Version = '2';

export interface AddToCartEvent extends BasicEvent {
    /** Type of the event. Must be AddToCart */
    eventName: ZenitEventName.AddToCart;
    payload: Payload<AddToCartContext>;
    version: Version;
}

export enum OriginAddToCart {
    addAll = 'add-all',
    bundle = 'bundle',
    buyLater = 'buy-later',
    edited = 'edited',
    external = 'external',
    grid = 'grid',
    increase = 'increase',
    list = 'list',
    mainCtaPdp = 'main-cta-pdp',
    matchWith = 'match-with',
    mayAlsoLike = 'may-also-like',
    miniShopcart = 'mini-shopcart',
    scan = 'scan',
    search = 'search',
    shopcart = 'shopcart',
    sizeRecommender = 'size-recommender',
    virtualTryOn = 'virtual-try-on',
    wishlist = 'wishlist',
}

export interface AddToCartContext {
    /** Unique identifier of the cart that receives the add action */
    cartId: string;
    categoryId: number | null;
    categoryURL: string | null;
    /** Unique identifier of the product entry in a category */
    catentryId: number;
    /** Object that collects the different properties in order to track the origin of a recommended product */
    clickOrigin: ZenitClickOrigin;
    /** Locale style ISO-639 Language Code followed by ISO-3166 Country Code, examples: es_ES, es_MX */
    displayLanguage: string;
    /**  Which element of the user interface was used to add the item to the cart. Must be one of the enum list */
    list: ZenitList;
    /** The position on the list of the element added to cart (only when adding from list) */
    listPosition: number | null;
    /** Which part of the interface was the origin of this user adding a product to the cart. Can be null if it is not possible to know the origin of the action. In case it is not null, must be one of enum list */
    origin: OriginAddToCart | null;
    /** Type of page that user from which the product is added. Must be one of the list */
    pageType: ZenitPageType;
    /** The Partnumber uniquely identifies any element in the catalog. Must have the format as in the next example: "C01165402712000-V2023". NOTE: If value cannot be sent use a code value of -1' */
    partnumber: string;
    /** Section that user is accessing. Must be one of the enum list */
    section: Section | null;
    /** List of SKUs as strings including campaign. This is MOCACOTA. Example: ["0807324080005-I2021"] */
    skus: string[];
    /** Ecommerce Online Store Id - References OnlineStore entity */
    storeId: number;
    /** Brandcode associated with the selected item [Bershka: 4, Lefties: 8, MassimoDutti: 11, Oysho: 7, Pull&Bear: 2, Stradivarius: 6, Uterqüe: 18, Zara: 1, 16, ZaraHome: 14] */
    brandId: 11;
}
